import { TProps } from './types/TProps';
import { Wrapper } from './styles/Wrapper';

export const Switch = ({ onChange, checked = false, disabled = false, className = 'switch' }: TProps) => (
  <Wrapper className={className} onClick={onChange} checked={checked} disabled={disabled}>
    <span className="point"></span>
  </Wrapper>
);
